import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('post', `/api/courses/${id}/add_co_teacher`,
    payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/inviteCoTeacher.js